import { render, staticRenderFns } from "./DashboardListInvestorProfileProperties.vue?vue&type=template&id=578559ba&"
import script from "./DashboardListInvestorProfileProperties.vue?vue&type=script&lang=js&"
export * from "./DashboardListInvestorProfileProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports